import "./App.css";
import { HashRouter as Router, Switch, Route,Redirect } from "react-router-dom";
import { Component } from "react";
import Auth from "./Components/Auth/Auth";
import Dock from "./Components/Dock/layout";
class App extends Component {
  state = {
    auth: false,
  };

  authCredsPresent =
    localStorage.getItem("token") &&
    localStorage.getItem("user") &&
    localStorage.getItem("name") &&
    localStorage.getItem("company");

  componentDidMount = async () => {
    let auth = false;
    if (this.authCredsPresent) {
      auth = true;
    }

    this.setState({ auth: auth });
  };

  changeAuthStatus = (value) => {
    if (value === true || value === false) this.setState({ auth: value });
  };
  render() {
    return (
      <Router>
        <Switch>
          {!this.authCredsPresent && !this.state.auth ? (
            <Route
              path="/"
              component={() => <Auth setAuth={this.changeAuthStatus} />}
            ></Route>
          ) : null}
          <Redirect exact from='/' to='/dashBoard'/>
          <Route exact path="/dashBoard" component={() => <Dock />}></Route>
          <Route
            exact
            path="/login"
            component={() => <Auth setAuth={this.changeAuthStatus} />}
          ></Route>
          <Route exact path="/register" component={() => <Auth />}></Route>
          <Route
            exact
            path="/forgot-password"
            component={() => <Auth />}
          ></Route>
          <Route path="/" component={() => <Dock />}></Route>
        </Switch>
      </Router>
    );
  }
}

export default App;
